module.exports = __webpack_public_path__ + "img/app-2.5f473a0f.png";